import script from "./tree.vue?vue&type=script&setup=true&lang=js"
export * from "./tree.vue?vue&type=script&setup=true&lang=js"

import "./tree.vue?vue&type=style&index=0&id=4e0645cc&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e0645cc"]])

export default __exports__